import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createAction } from 'redux-actions';
export const fetchLayoutSuccess = createAction('@@gruser.LAYOUT.FETCH.SUCCESS', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const moveModule = createAction('@@gruser.LAYOUT.MOVE_MODULE', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const removeModule = createAction('@@gruser.LAYOUT.REMOVE_MODULE', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const removeModuleSuccess = createAction('@@gruser.LAYOUT.REMOVE_MODULE_SUCCESS', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const updateModuleOrderSuccess = createAction('@@gruser.LAYOUT.UPDATE_MODULE_ORDER.SUCCESS', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const addModule = createAction('@@gruser.LAYOUT.ADD_MODULE', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const addModuleSuccess = createAction('@@gruser.LAYOUT.ADD_MODULE_SUCCESS', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const addModuleFail = createAction('@@gruser.LAYOUT.ADD_MODULE_FAIL', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));
export const updateLayoutVersion = createAction('@@gruser.LAYOUT.UPDATE_VERSION', (gruser, payload)=>_object_spread_props(_object_spread({}, payload), {
        gruser
    }));

//# sourceMappingURL=layout.js.map